import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overflow-x-auto"
}
const _hoisted_2 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_3 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_4 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_5 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_6 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_7 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_8 = { class: "text-sm text-gray-900" }
const _hoisted_9 = { class: "text-xs text-gray-500" }
const _hoisted_10 = { class: "px-6 py-4" }
const _hoisted_11 = { class: "flex flex-col space-y-1" }
const _hoisted_12 = {
  key: 0,
  class: "text-xs bg-red-50 p-1 rounded border border-red-100"
}
const _hoisted_13 = { class: "text-gray-800" }
const _hoisted_14 = {
  key: 1,
  class: "text-xs bg-green-50 p-1 rounded border border-green-100"
}
const _hoisted_15 = { class: "text-gray-800" }
const _hoisted_16 = { class: "px-6 py-4 text-sm" }
const _hoisted_17 = {
  key: 0,
  class: "flex flex-col space-y-2"
}
const _hoisted_18 = { class: "flex justify-end space-x-2" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 1,
  class: "flex justify-between items-start"
}
const _hoisted_21 = { class: "text-gray-500 max-w-xs" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 1,
  class: "p-4 text-center bg-gray-50 border rounded"
}

import { ref } from "vue";
import { useEquipment } from "@/composables/tasks/useEquipment";
import { useTaskHistory } from "@/composables/tasks/useTaskHistory";
import { TaskHistoryEntry } from "@/types/v2";

// Get equipment functions

export default /*@__PURE__*/_defineComponent({
  __name: 'EquipmentHistory',
  setup(__props) {

const { getEquipmentHistory, formatTimestamp } = useEquipment();
const taskHistory = useTaskHistory();

// State for editing history justifications
const editingHistoryEntry = ref<TaskHistoryEntry | null>(null);
const editedJustification = ref('');

// Start editing a history entry's justification
const startEditingHistory = (entry: TaskHistoryEntry) => {
  editingHistoryEntry.value = entry;
  editedJustification.value = entry.justification || '';
};

// Cancel editing history
const cancelEditingHistory = () => {
  editingHistoryEntry.value = null;
  editedJustification.value = '';
};

const saveHistoryJustification = (entry: TaskHistoryEntry) => {
  const history = taskHistory.getHistory();
  const entryIndex = history.findIndex(e => e.id === entry.id);

  if (entryIndex === -1) return;

  history[entryIndex].justification = editedJustification.value;

  // Reset editing state
  editingHistoryEntry.value = null;
  editedJustification.value = '';
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "text-lg font-semibold mb-4" }, "Equipment Change History", -1)),
    (_unref(getEquipmentHistory).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("table", _hoisted_2, [
            _cache[3] || (_cache[3] = _createElementVNode("thead", { class: "bg-gray-50" }, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                }, "Timestamp"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                }, "User"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                }, "Field"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                }, "Change"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                }, "Justification")
              ])
            ], -1)),
            _createElementVNode("tbody", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getEquipmentHistory), (entry) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: entry.id,
                  class: "hover:bg-gray-50"
                }, [
                  _createElementVNode("td", _hoisted_4, _toDisplayString(_unref(formatTimestamp)(entry.timestamp)), 1),
                  _createElementVNode("td", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(entry.userName), 1)
                  ]),
                  _createElementVNode("td", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(entry.fieldName), 1),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(entry.context), 1)
                  ]),
                  _createElementVNode("td", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      (entry.oldValue !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "font-semibold text-red-700" }, "Old:", -1)),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(typeof entry.oldValue === 'object' ? JSON.stringify(entry.oldValue) : entry.oldValue), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (entry.newValue !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "font-semibold text-green-700" }, "New:", -1)),
                            _createElementVNode("span", _hoisted_15, _toDisplayString(typeof entry.newValue === 'object' ? JSON.stringify(entry.newValue) : entry.newValue), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_16, [
                    (editingHistoryEntry.value && editingHistoryEntry.value.id === entry.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editedJustification).value = $event)),
                            class: "w-full border border-gray-300 rounded p-2 text-sm",
                            rows: "3",
                            placeholder: "Enter justification..."
                          }, null, 512), [
                            [_vModelText, editedJustification.value]
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (saveHistoryJustification(entry)),
                              class: "px-3 py-1 bg-green-600 text-white text-xs rounded hover:bg-green-700"
                            }, " Save ", 8, _hoisted_19),
                            _createElementVNode("button", {
                              onClick: cancelEditingHistory,
                              class: "px-3 py-1 bg-gray-600 text-white text-xs rounded hover:bg-gray-700"
                            }, " Cancel ")
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, _toDisplayString(entry.justification || '-'), 1),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (startEditingHistory(entry)),
                            class: "ml-2 px-2 py-1 bg-gray-100 text-xs rounded hover:bg-gray-200",
                            title: "Edit justification"
                          }, " Edit ", 8, _hoisted_22)
                        ]))
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[4] || (_cache[4] = [
          _createElementVNode("p", { class: "text-gray-500" }, "No equipment change history available.", -1)
        ])))
  ]))
}
}

})